import { gql } from "@apollo/client";

const GET_NOTIFICATIONS = gql`
  query Notifications($first: Int, $after: String) {
    notifications(first: $first, after: $after) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        id
        title
        content
        actionText
        actionUrl
        readAt
        createdAt
      }
    }
  }
`;

export default GET_NOTIFICATIONS;
